function calculateBubbleSize(correlacao) {
  return Math.abs(correlacao) * 1000 * 2;
}

/**
 * {
 *   id: number;
 *   enunciado: string;
 *   alternativas: [
 *      {
 *        id: number;
 *        enunciado: string;
 *        perguntasCorrelacionadas: [
  *         {
  *            id: number;
  *            enunciado: string;
  *            alternativas: [
  *               {
  *                  id: number;
  *                  enunciado: string;
  *                  correlacao: number;
  *               }
  *            ]
  *         }
  *       ]
 *      }
 *   ]
 * }
 *
 * output:
 *
 * {
 *  perguntas: string[];                          // lista canônica em ordem de primeira aparição
 *  seriesByPergunta: [{ name, bubbles }];        // uma série por pergunta correlacionada
 * }
 *
 * Cada bubble é a tupla `[globalIndex, correlacao, bubbleSize, label, flag, resultado]`.
 * O `globalIndex` é monotonicamente crescente entre todas as séries para garantir
 * posições X únicas no eixo (que está oculto) e evitar bolhas sobrepostas.
 */
export default function toEchartData(perguntaCorrelacionada) {
  const empty = { perguntas: [], seriesByPergunta: [] };

  const hasData = perguntaCorrelacionada
    && perguntaCorrelacionada.alternativas;

  if (!hasData) return empty;

  const resultados = perguntaCorrelacionada.alternativas[0].perguntasCorrelacionadas
    .map((pergunta) => {
      const { id, enunciado } = pergunta;
      return pergunta.alternativas.map((alternativa) => ({
        resposta: {
          pergunta: {
            id,
            enunciado,
          },
          alternativa: {
            id: alternativa.id,
            enunciado: alternativa.enunciado,
          },
        },
        correlacao: alternativa.correlacao,
      }));
    })
    .reduce((reduced, next) => [...reduced, ...next], []);

  const perguntas = [];
  const seen = new Set();
  resultados.forEach((r) => {
    const e = r.resposta.pergunta.enunciado;
    if (!seen.has(e)) {
      seen.add(e);
      perguntas.push(e);
    }
  });

  let globalIndex = 0;
  const seriesByPergunta = perguntas.map((perguntaEnunciado) => {
    const bubbles = resultados
      .filter((r) => r.resposta.pergunta.enunciado === perguntaEnunciado && r.correlacao !== 0)
      .map((r) => {
        globalIndex += 1;
        const flag = r.correlacao > 0 ? 'proporcional' : 'inversamente';
        return [
          globalIndex,
          r.correlacao,
          calculateBubbleSize(r.correlacao),
          r.resposta.alternativa.enunciado,
          flag,
          r,
        ];
      });
    return { name: perguntaEnunciado, bubbles };
  });

  return { perguntas, seriesByPergunta };
}
